module.exports = __webpack_public_path__ + "static/hyperv_23.66bd70b0.jpg";